import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThumbnailButtonComponent } from './components/thumbnail-button/thumbnail-button.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FieldValidationDirective } from './directives/field-validation.directive';
import { NdmsInputComponent } from './forms/ndms-input/ndms-input.component';
import {NdmsTextboxComponent} from './forms/ndms-textbox/ndms-textbox.component';
import { NdmsFormControlComponent } from './forms/ndms-form-control/ndms-form-control.component';
import { NdmsValidationMessagesComponent } from './forms/ndms-validation-messages/ndms-validation-messages.component';
import { NdmsPhoneNumberComponent } from './forms/ndms-phone-number/ndms-phone-number.component';
import { NdmsAddressComponent } from './forms/ndms-address/ndms-address.component';
import { NdmsSelectComponent } from './forms/ndms-select/ndms-select.component';
import { NdmsDateComponent } from './forms/ndms-date/ndms-date.component';
import { NdmsEmailComponent } from './forms/ndms-email/ndms-email.component';
import { NdmsTextareaComponent } from './forms/ndms-textarea/ndms-textarea.component';
import { NdmsCheckboxComponent } from './forms/ndms-checkbox/ndms-checkbox.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { McBreadcrumbsModule } from 'ngx-breadcrumbs-ui';
import { NdmsRadioComponent } from './forms/ndms-radio/ndms-radio.component';
import { NdmsLabelComponent } from './forms/ndms-label/ndms-label.component';
import { NdmsPanelFormComponent } from './forms/ndms-panel-form/ndms-panel-form.component';
import { NdmsPanelFormMultipleComponent } from './forms/ndms-panel-form-multiple/ndms-panel-form-multiple.component';
import { NdmsDataDisplayComponent } from './forms/ndms-data-display/ndms-data-display.component';
import { AddressPipe } from './pipes/address.pipe';
import { PhonePipe } from './pipes/phone.pipe';
import { SsnMaskPipe } from './pipes/ssn-mask.pipe';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { SearchModalComponent } from './components/modals/search-modal/search-modal.component';
import { NdmsTextboxSearchComponent } from './forms/ndms-textbox-search/ndms-textbox-search.component';
import { NdmsNumberComponent } from './forms/ndms-number/ndms-number.component';
import { RouterModule } from '@angular/router';
import { SearchMultiSelectComponent } from './components/modals/search-multi-select/search-multi-select.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { NdmsCurrencyComponent } from './forms/ndms-currency/ndms-currency.component';
import { TextboxComponent } from './elements/textbox/textbox.component';
import { CurrencyComponent } from './elements/currency/currency.component';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { CardComponent } from './elements/card/card.component';
import { NdmsCardFormComponent } from './forms/ndms-card-form/ndms-card-form.component';
import { NdmsTimeComponent } from './forms/ndms-time/ndms-time.component';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TextMaskModule } from 'angular2-text-mask';
import {FocusModule} from 'angular2-focus';
import { NdmsWristbandComponent } from './forms/ndms-wristband/ndms-wristband.component';
import { WristbandPipe } from './pipes/wristband.pipe';
import { ConfirmDeleteComponent } from './components/modals/confirm-delete/confirm-delete.component';
import { ConfirmDeleteLookupComponent } from './components/modals/confirm-delete/confirm-delete-lookup.component';
import { ConfirmMoveComponent } from './components/modals/confirm-move/confirm-move.component';
import { ConfirmRemoveComponent } from './components/modals/confirm-remove/confirm-remove.component';
import { TableModule } from 'primeng/table';
import { ChartsModule } from 'ng2-charts';
import { AngularEsriModule } from 'angular-esri-components';
import { MapEsriComponent } from './components/map-esri/map-esri.component';
import { PagingPipe } from './pipes/paging.pipe';
import { FacilityPipe } from './pipes/facility.pipe';
import { AsprFooterComponent } from './components/aspr-footer/aspr-footer.component';
import { BarcodeComponent } from "./components/barcode/barcode.component";
import {NdmsSimpleSelectComponent} from "./forms/ndms-simple-select/ndms-simple-select.component";
import {SafeHtmlPipe} from "./pipes/safeHtml.pipe";
import {NdmsLookupSelectComponent} from "./forms/ndms-lookup-select/ndms-lookup-select.component";
import {InputSwitchModule} from 'primeng/inputswitch';
import { Last4MaskPipe } from './pipes/last4-mask.pipe';
import { DebounceClickDirective } from './directives/debounce-click.directive';

import { TreeModule } from "primeng/tree";
import { RadioButtonModule } from "primeng/radiobutton";
import { CalendarModule } from "primeng/calendar";
import {NdmsIdSelectComponent} from "./forms/ndms-id-select/ndms-id-select.component";
import { PostalCodePipe } from './pipes/postal-code.pipe';
import { FileUploadModule } from 'primeng/fileUpload';
import { SplitTakePipe } from './pipes/split-take.pipe';
import { CreditCardMaskPipe } from './pipes/credit-card-mask.pipe';
import {LocalDatePipe} from "./pipes/local-date.pipe";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SimpleNotificationsModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    PaginationModule.forRoot(),
    TooltipModule.forRoot(),
    ModalModule.forRoot(),
    TabsModule.forRoot(),
    AccordionModule.forRoot(),
    ProgressbarModule.forRoot(),
    FocusModule.forRoot(),
    RouterModule,
    TreeModule,
    TextMaskModule,
    CalendarModule,
    TableModule,
    ChartsModule,
    AngularEsriModule,
    FileUploadModule
  ],
  declarations: [
    ThumbnailButtonComponent,
    FieldValidationDirective,
    NdmsInputComponent,
    NdmsTextboxComponent,
    NdmsFormControlComponent,
    NdmsValidationMessagesComponent,
    NdmsPhoneNumberComponent,
    NdmsAddressComponent,
    AsprFooterComponent,
    BarcodeComponent,
    NdmsSimpleSelectComponent,
    NdmsLookupSelectComponent,
    NdmsSelectComponent,
    NdmsDateComponent,
    NdmsEmailComponent,
    NdmsTextareaComponent,
    NdmsCheckboxComponent,
    TooltipComponent,
    NdmsRadioComponent,
    NdmsLabelComponent,
    NdmsPanelFormComponent,
    NdmsPanelFormMultipleComponent,
    NdmsDataDisplayComponent,
    AddressPipe,
    PhonePipe,
    SsnMaskPipe,
    Last4MaskPipe,
    SafeHtmlPipe,
    SplitTakePipe,
    CreditCardMaskPipe,
    LocalDatePipe,
    NdmsNumberComponent,
    SearchModalComponent,
    NdmsTextboxSearchComponent,
    SearchMultiSelectComponent,
    NdmsCurrencyComponent,
    TextboxComponent,
    CurrencyComponent,
    CardComponent,
    NdmsCardFormComponent,
    NdmsTimeComponent,
    NdmsWristbandComponent,
    WristbandPipe,
    ConfirmDeleteComponent,
    ConfirmDeleteLookupComponent,
    ConfirmMoveComponent,
    ConfirmRemoveComponent,
    MapEsriComponent,
    NdmsIdSelectComponent,
    PagingPipe,
    FacilityPipe,
    DebounceClickDirective,
    PostalCodePipe

  ],
  exports: [
    CommonModule,
    ThumbnailButtonComponent,
    FormsModule,
    AsprFooterComponent,
    BarcodeComponent,
    ReactiveFormsModule,
    NdmsInputComponent,
    NdmsDateComponent,
    NdmsTextboxComponent,
    NdmsCheckboxComponent,
    NdmsValidationMessagesComponent,
    NdmsRadioComponent,
    NdmsLabelComponent,
    NdmsEmailComponent,
    NdmsTextareaComponent,
    NdmsDataDisplayComponent,
    NdmsPanelFormComponent,
    NdmsPanelFormMultipleComponent,
    NdmsPhoneNumberComponent,
    NdmsAddressComponent,
    NdmsSelectComponent,
    NdmsSimpleSelectComponent,
    NdmsLookupSelectComponent,
    NdmsTextareaComponent,
    TooltipComponent,
    McBreadcrumbsModule,
    AddressPipe,
    PhonePipe,
    SsnMaskPipe,
    Last4MaskPipe,
    SafeHtmlPipe,
    SplitTakePipe,
    CreditCardMaskPipe,
    LocalDatePipe,
    PaginationModule,
    SimpleNotificationsModule,
	  NdmsNumberComponent,
    SearchModalComponent,
    NdmsTextboxSearchComponent,
    SearchMultiSelectComponent,
    RouterModule,
    AccordionModule,
    TabsModule,
    RadioButtonModule,
    TreeModule,
    ModalModule,
    NdmsCurrencyComponent,
    CurrencyComponent,
    ProgressbarModule,
    CardComponent,
    NdmsCardFormComponent,
    NdmsTimeComponent,
    NdmsWristbandComponent,
    WristbandPipe,
    ConfirmDeleteComponent,
    ConfirmDeleteLookupComponent,
    ConfirmRemoveComponent,
    NdmsIdSelectComponent,
    TableModule,
    ChartsModule,
    MapEsriComponent,
    PagingPipe,
    FacilityPipe,
    InputSwitchModule,
    DebounceClickDirective,
    PostalCodePipe,
    FileUploadModule
  ],
  entryComponents: [
    NdmsTextboxComponent,
    ConfirmDeleteComponent,
    ConfirmDeleteLookupComponent,
    ConfirmMoveComponent,
    ConfirmRemoveComponent
  ],
  providers: [PostalCodePipe]
})
export class UiNdmsModule { }
